module.exports = __webpack_public_path__ + "f25ff17acc9c6c48c2209f0a9815706a.png";